import {
    TableViewStore,
    BaseListViewStore
} from 'core/stores';
import applicationContext from 'core/utils/applicationContext';
import { TemplateService } from 'application/patient/services';
import {toDate} from 'core/utils';
import _ from 'lodash';

@applicationContext
class PatientTemplateListViewStore extends BaseListViewStore {
    constructor(rootStore) {
        const service = new TemplateService(rootStore.application.baasic.apiClient); 
        const routeParams = rootStore.routerStore.routerState.params;

        super(rootStore, {
            name: 'patient',
            autoInit: true,
            routes: {
                 preview: item => {
                    this.rootStore.routerStore.setTransitionData({
                        navigationTitle: item.templateName + ', ' + routeParams.firstName + ' ' + routeParams.lastName 
                    });
                    return this.rootStore.routerStore.goTo(
                        'master.app.main.patient.preview.templates.preview',
                        _.extend(routeParams, {templateId: item.templateId})
                    )
                }
            },
            actions: () => {
                return {
                    find: async (params) => {
                        const response = await service.find(_.extend(params, {patientId: this.rootStore.routerStore.routerState.params.id}));
                        let items = _.map(response.data.item, item => {
                            return {
                                templateId: item.brightreeId,
                                branch: item.salesOrderTemplateGeneralInfo.branch,
                                nextRunDate: toDate(item.nextRunDate),
                                previousRunDate: toDate(item.previousRunDate),
                                templateStatus: item.salesOrderTemplateGeneralInfo.templateStatus,
                                templateType: item.salesOrderTemplateGeneralInfo.templateType,
                                templateName: item.templateName
                            }
                          })
                          response.data.item = items;
                          return response.data.item;
                    }
                }
            }
        });

         this.setTableStore(new TableViewStore(this.queryUtility, {
            columns: [
                {
                    key: 'templateName',
                    title: 'TEMPLATES.LIST.COLUMNS.TEMPLATE_NAME',
                    sort: false,
                },
                {
                    key: 'templateId',
                    title: 'TEMPLATES.LIST.COLUMNS.TEMPLATE_ID',
                    sort: false,
                },
                {
                    key: 'branch',
                    title: 'TEMPLATES.LIST.COLUMNS.BRANCH_NAME',
                    sort: false,
                },
                {
                    key: 'nextRunDate',
                    title: 'TEMPLATES.LIST.COLUMNS.NEXT_RUN_DATE',
                    sort: false,
                }
            ],
             actions: {
                onPreview: (item) => this.routes.preview(item)
            } 
        })); 
    }
}

export default PatientTemplateListViewStore;
